/* RESPONSIBLE TEAM: team-standalone */
import { BaseConfig } from '@intercom/composer-ember';
import type AttributeInfoResolver from 'embercom/lib/common/template-attribute-resolver';

const DEFAULT_COMPOSER_MAX_CHARACTER_COUNT = 64000;

export class StandaloneComposerConfig extends BaseConfig {
  autoFocus = true;
  textDirection = 'ltr' as const;
  allowedBlocks = ['paragraph'];
  allowedInline: string[] = [];
  allowTextAlignment = false;
  singleBlockMode = true;
  isPlaintext = true;
  maxCharacterCount: number;
  tools = [{ name: 'template-inserter' }, { name: 'fallback-editor' }];
  experimental = {
    hideInsertersOnMouseOut: true,
  };
  templating: { picker: string; resolver: AttributeInfoResolver };

  constructor({
    resolver,
    placeholder = '',
    maxCharacterCount = DEFAULT_COMPOSER_MAX_CHARACTER_COUNT,
    singleBlockMode = true,
    autoFocus = true,
    allowedInline = [] as string[],
  }: {
    resolver: AttributeInfoResolver;
    placeholder?: string;
    maxCharacterCount?: number;
    singleBlockMode?: boolean;
    autoFocus?: boolean;
    allowedInline?: string[];
  }) {
    super();
    this.placeholder = placeholder;
    this.maxCharacterCount = maxCharacterCount;
    this.singleBlockMode = singleBlockMode;
    this.autoFocus = autoFocus;
    this.allowedInline = allowedInline;
    this.isPlaintext = allowedInline.length === 0;
    this.templating = { picker: 'common/attribute-picker', resolver };

    if (allowedInline.length > 0) {
      this.tools.push({ name: 'text-formatter' });
      this.hideFromTextFormatter = ['inline_control_block_types'];
    }
    if (allowedInline.includes('anchor')) {
      this.tools.push({ name: 'anchor-editor' });
    }
  }
}
